import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { GridValidRowModel } from "@mui/x-data-grid";
import { SweepDestStatus } from "@wallet-manager/node-types/dist/src/postgres/const";
import BigNumber from "bignumber.js";
import { Dispatch, SetStateAction } from "react";
import MpTextFieldNumberOnly from "src/components/MpTextFieldNumberOnly";
import { Box, Typography } from "src/components/MuiGenerals";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import LayoutRow from "src/views/WalletManagement/TronWalletResourceBalance/components/LayoutRow";
import { EditRecordFields } from "../types/EditRecipientFields";
import { ViewGroupGetListRes } from "../types/ViewGroupGetListRes";
import { TableColumnKey } from "../../../types/Table";

type Props = {
  selectedRow?: GridValidRowModel & { rawData: ViewGroupGetListRes };
  editRecordFields?: EditRecordFields;
  setEditRecordFields: Dispatch<SetStateAction<EditRecordFields | undefined>>;
};

const EditRecipientDialogContent = (props: Props) => {
  const { selectedRow, editRecordFields, setEditRecordFields } = props;
  const { translatePrefix } = usePageConfigProviderContext();
  const { t, tc, te } = useTranslation(translatePrefix);

  return (
    <Box
      sx={{
        margin: "8px 0",
        "& .MuiFormControl-root": {
          width: "100%",
        },
      }}
      display={"flex"}
      flexDirection={"column"}
      gap={1}>
      <LayoutRow
        title={t(TableColumnKey.ChainName)}
        content={
          <Typography style={{ textAlign: "right" }}>
            {selectedRow?.[TableColumnKey.ChainName]}
          </Typography>
        }
      />
      <LayoutRow
        title={t(TableColumnKey.Currency)}
        content={
          <Typography style={{ textAlign: "right" }}>
            {selectedRow?.[TableColumnKey.Currency]}
          </Typography>
        }
      />
      <LayoutRow
        title={t(TableColumnKey.RecipientAddress)}
        content={
          <Typography style={{ textAlign: "right" }}>
            {selectedRow?.[TableColumnKey.RecipientAddress]}
          </Typography>
        }
      />
      <LayoutRow
        title={t(TableColumnKey.RiskType)}
        content={
          <Typography style={{ textAlign: "right" }}>
            {selectedRow?.[TableColumnKey.RiskType]}
          </Typography>
        }
      />
      <LayoutRow
        title={t(TableColumnKey.Status)}
        content={
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-end"}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={(e) => {
                setEditRecordFields((f) => ({ ...f, status: e.target.value }));
              }}
              value={editRecordFields?.status}>
              <FormControlLabel
                value={SweepDestStatus.Enable}
                control={<Radio />}
                label={te("enable")}
              />
              <FormControlLabel
                value={SweepDestStatus.Disable}
                sx={{ marginRight: 0 }}
                control={<Radio />}
                label={te("disable")}
              />
            </RadioGroup>
          </Box>
        }
      />
      <LayoutRow title={t(TableColumnKey.Rating)} />
      <MpTextFieldNumberOnly
        label={tc("phInputField", { fieldName: t(TableColumnKey.Rating) })}
        value={editRecordFields?.probability}
        onChange={(e) => {
          if (BigNumber(e.target.value).lte(100) || !e.target.value) {
            setEditRecordFields((f) => ({ ...f, probability: e.target.value }));
          }
        }}
      />
    </Box>
  );
};

export default EditRecipientDialogContent;
